// This needs to either be replaced entirely by brightcove video or wrap and
// extend to continue using some of the listeners/watches within this directive.
import { reject } from 'lodash';
import { brightcove } from 'settings';

export const WorkoutPlayerVideo = ($q, $timeout, $window, $log) => {
  'ngInject';

  return {
    link,

    scope: {
      autoplay: '=',
      countdownComplete: '=',
      playing: '=',
      waiting: '=',
      onPlay: '&',
      onResume: '&',
      onWait: '&',
    },

    template: `
      <div class="workout-player-video">
        <video class="video-js"
          id="brightcove-workout-player"
          data-account="${brightcove.accountId}"
          data-player="${brightcove.playerId}"
          data-embed="default"
          playsinline
          muted
          controls>
        </video>
        <div class="cover-screen" ng-class="{ 'on': coverOn }"></div>
        <div loading-spinner="!$ctrl.waiting && !coverOn"></div>
      </div>`,
  };

  function link(scope, element, attrs) {
    var $video_el;

    scope.isLoaded = false;

    scope.init = function() {
      $($window).resize(function() {
        scope.setScale();
      });

      attrs.$observe('videoScale', function() {
        scope.setScale();
      });

      attrs.$observe('videoId', function() {
        scope.setExperience();
      });

      scope.$watch('playing', function(playing) {
        if (playing) {
          scope.onWait();

          scope
            .loadVideo()
            .then(() => {
              scope.onResume();
              scope.play();
            })
            .catch(() => {});
        } else {
          scope.pauseVideo();
        }
      });

      scope.$watch('countdownComplete', () => {
        scope.play();
      });

      scope.$on('$destroy', function() {
        if (scope.player) {
          scope.player.dispose();
          scope.player = undefined;

          $('.workout-player-video').remove();
        }
      });

      return scope.injectBrightcoveScript();
    };

    scope.injectBrightcoveScript = function() {
      var deferred = $q.defer();

      if (scope.player) {
        deferred.resolve();
      } else {
        var script = document.createElement('script');

        script.src = `${$window.location.protocol}//players.brightcove.net/${
          brightcove.accountId
        }/${brightcove.playerId}_default/index.min.js`;

        script.onload = () => {
          deferred.resolve();
        };

        document.body.appendChild(script);
      }

      return deferred.promise;
    };

    scope.setPlayer = function() {
      scope.player = $window.videojs('brightcove-workout-player');

      // Manually loop when the video ends to fix issues with Safari
      scope.player.on('ended', () => scope.playVideo());

      // If the browser can't play the video type (MEDIA_ERR_SRC_NOT_SUPPORTED)
      // then remove that type from the sources and try again.
      // This has been ripped from brightcove.video, the aim is to get
      // this directive updated to use brightcove.video.
      scope.player.on('error', function() {
        const playerError = scope.player.error();
        const playerType = scope.player.currentType();

        if (playerError && playerError.code === 4) {
          scope.video_data.sources = reject(
            scope.video_data.sources,
            source => {
              return source.type === playerType;
            }
          );

          scope.isLoaded = false;
          scope.player.src(scope.video_data.sources);
          scope.player.load();
        }
      });

      element
        .find('.vjs-big-play-button')
        .off('click')
        .on('click', () => scope.onPlay());

      $video_el = element.find('.video-js');

      $('.vjs-loading-spinner').remove();
    };

    scope.setVideoData = function() {
      var deferred = $q.defer();
      var id = attrs.videoId;

      if (scope.player && id) {
        scope.player.catalog.getVideo(id, function(error, video_data) {
          scope.video_data = video_data;
          deferred.resolve();
        });
      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    scope.loadVideo = function() {
      var deferred = $q.defer();

      if (!scope.autoplay) {
        deferred.resolve();
      } else if (
        scope.player &&
        scope.video_data &&
        !scope.video_data.video_loaded
      ) {
        scope.player.one('loadeddata', function() {
          scope.$emit('video-player:loadeddata');
          scope.video_data.video_loaded = true;
          scope.player.pause();
          deferred.resolve();
        });
        scope.$emit('video-player:loaddata');
        scope.player.src(scope.video_data.sources);
        scope.player.load();
      } else if (
        scope.player &&
        scope.video_data &&
        scope.video_data.video_loaded
      ) {
        deferred.resolve();
      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    scope.loadPoster = function() {
      var deferred = $q.defer();

      if (scope.player && scope.video_data) {
        scope.video_data.poster = scope.video_data.poster.replace(
          '/original/',
          '/large/'
        );

        $timeout(function() {
          $('<img>')
            .attr('src', scope.video_data.poster)
            .on('load', () => deferred.resolve());
        });
      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    scope.setPoster = function() {
      if ($video_el && $video_el.length > 0) {
        $video_el.toggleClass('vjs-has-started', false);
      }

      scope.player.poster(scope.video_data.poster);
    };

    scope.clearPoster = function() {
      scope.player.poster('');
    };

    scope.playVideo = function() {
      if (scope.player && scope.autoplay) {
        $timeout(() => {
          const videoPromise = scope.player.play();

          // Shut the error messages up.
          if (videoPromise && videoPromise.then) {
            videoPromise.then(() => (scope.isLoaded = true)).catch(() => {});
          } else {
            scope.isLoaded = true;
          }
        });
      }
    };

    scope.pauseVideo = function() {
      if (scope.player && scope.autoplay && scope.isLoaded) {
        $timeout(() => scope.player.pause());
      }
    };

    scope.setScale = function() {
      if ($video_el && $video_el.length > 0) {
        var w = $video_el.width(),
          h = $video_el.height() + 10,
          aspect = w / h,
          base_scale = 1 / aspect * 16 / 9,
          scale = parseFloat(attrs.videoScale || 1) * base_scale * 100,
          offset = (100 - scale) / 2;

        $('.vjs-tech, .vjs-poster').css({
          height: scale + '%',
          width: scale + '%',
          top: offset + '%',
          left: offset + '%',
        });
      }
    };

    scope.setExperience = function() {
      scope.coverOn = true;
      scope.onWait();

      if (scope.player) {
        scope.player.reset();
        scope.setScale();
      }

      scope
        .setVideoData()
        .then(() => {
          scope.loadPoster().then(() => {
            scope.setPoster();
            scope.coverOn = false;
            scope.onResume();

            if (!scope.autoplay) {
              scope.player.src(scope.video_data.sources);
            } else if (scope.playing) {
              scope
                .loadVideo()
                .then(() => {
                  scope.clearPoster();
                  scope.play();
                })
                .catch(() => {});
            }
          });
        })
        .catch(() => {});
    };

    scope.play = function() {
      if (scope.countdownComplete) {
        scope.playVideo();
      }
    };

    scope.init().then(function() {
      scope.setPlayer();
      scope.setScale();
      scope.setExperience();
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerVideo.js